import React, { Component } from "react";
class ServerException extends Component {
  state = {};
  render() {
    return <div></div>;
  }
}

export default ServerException;
